@if (products && products.length > 0) {
  <div>
    <section class="product-list__wrapper row">
      @for (product of products; track product; let i = $index) {
        <div
          class="product-list__item col-xl-3 col-lg-4 col-md-6 col-sm-6 col-6"
          [ngClass]="{ 'col-xl-4 col-lg-6 col-md-12 col-sm-12 col-xs-6': isFilterOpen }"
        >
          <app-product-card
            [product]="product"
            [colorReferences]="colorReferences"
            [displaySpecificProductCampaignHighlights]="displaySpecificProductCampaignHighlights"
            (addToCart)="onAddToCart($event)"
          />
        </div>
      }
    </section>

    <!-- Added to cart modal -->
    <app-modal
      sourceId="offcanvas_product_modal_{{ uniqueModalId }}"
      title="Added to cart"
      i18n-title="@@product.productAddedToCart"
      [modalClass]="'product-modal'"
    >
      <ng-container class="product__modal_added_to_cart">
        <app-product-added-to-cart
          [cartProduct]="cartProductAdded"
          [productPrice]="productPrice"
          [productStock]="productStock"
          [quantity]="getProductQuantity(cartProductAdded)"
          (closeModalEvent)="closeAddedToCartModal()"
        />
        <app-cross-sell-products-template
          [crossSellProducts]="crossSellProducts"
          (addCrossSellProductToCartEvent)="onAddToCart($event)"
        />
      </ng-container>
    </app-modal>

    <app-modal
      #ModalErrorComponent
      title="Quantity Error"
      [sourceId]="'quantityErrorModal' + uniqueModalId"
      [closeBackDrop]="true"
      [modalClass]="'quantity-error__modal'"
      i18n-title="@@product.maxQuantityErrorTitle"
      ><p i18n="@@product.maxQuantityErrorTextAux">
        You have exceeded the maximum quantity of the product, a total of
        {{ MAX_ITEM_QUANTITY }} units of the product have been added.
      </p>
      <div class="quantity-error__buttons">
        <button type="button" class="btn btn-secondary" i18n="@@CLOSE" (click)="closeQtyErrorModal()">Close</button>
      </div>
    </app-modal>

    <app-modal
      #ModalErrorComponentCartMaxValue
      i18n-title="@@product.maxCartQuantityErrorTitle"
      title="Quantity Error"
      [closeBackDrop]="true"
      [modalClass]="'quantity-error__modal'"
      [sourceId]="'quantityErrorModalCartMaxValue' + uniqueModalId"
    >
      <p i18n="@@product.maxCartQuantityErrorTextAux">
        There are too many products in your cart, please reduce the number of products selected.
      </p>
      <div class="quantity-error__buttons">
        <button type="button" class="btn btn-secondary" i18n="@@CLOSE" (click)="closeQuantityErrorCartMaxValueModal()">
          Close
        </button>
      </div>
    </app-modal>
  </div>
} @else {
  <div>
    <p class="" i18n="@@noProductsResults">There are no results for selected filters.</p>
  </div>
}
